import { render, staticRenderFns } from "./ConceptsPrices.vue?vue&type=template&id=3de929dc&scoped=true"
import script from "./ConceptsPrices.vue?vue&type=script&lang=ts"
export * from "./ConceptsPrices.vue?vue&type=script&lang=ts"
import style0 from "./ConceptsPrices.vue?vue&type=style&index=0&id=3de929dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3de929dc",
  null
  
)

export default component.exports